(() => {
  if (customElements.get('kom-shipping-progress')) return;
  class KomShippingProgress extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      document.addEventListener('cart:change', event => this.update(event.detail?.cart), options);
      document.addEventListener('cart:refresh', () => this.refresh(), options);
      window.addEventListener('pageshow', () => this.refresh(), options);
      document.addEventListener('variant:change', event => {
        if (!this.dataset.form || event.target.getAttribute?.('id') !== this.dataset.form) return;
        this.dataset.price = String(event.detail.variant?.price || 0);
        this.dataset.available = String(!!event.detail.variant?.available);
        this.update(this.cart);
      }, options);
      const quantityChanged = event => {
        if (this.dataset.form && event.target.name === 'quantity' && event.target.form?.getAttribute('id') === this.dataset.form) this.update(this.cart);
      };
      document.addEventListener('change', quantityChanged, options);
      document.addEventListener('input', quantityChanged, options);
      this.refresh();
    }
    disconnectedCallback() { this.controller?.abort(); }
    async refresh() {
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {signal:this.controller.signal,cache:'no-store'});
        if (response.ok) this.update(await response.json());
      } catch (_) {}
    }
    update(cart) {
      if (!cart || !Number.isFinite(cart.total_price)) return;
      this.cart = cart;
      this.hidden = cart.currency !== 'COP';
      if (this.hidden) return;
      const target = Number(this.dataset.target);
      const form = this.dataset.form && document.getElementById(this.dataset.form);
      const quantity = Math.max(1, Number(form?.elements.namedItem('quantity')?.value) || 1);
      const forecast = !!this.dataset.form && this.dataset.available === 'true' && cart.total_price < target;
      const total = cart.total_price + (forecast ? Number(this.dataset.price) * quantity : 0);
      const remaining = Math.max(0, target-total);
      const percent = Math.min(100,Math.max(0,total/target*100));
      const language = document.documentElement.lang || 'es-CO';
      const formatted = new Intl.NumberFormat(language.startsWith('es') ? 'es-CO' : language,{style:'currency',currency:'COP',maximumFractionDigits:0}).format(remaining/100);
      const message = forecast
        ? (remaining === 0 ? this.dataset.afterSuccess : this.dataset.afterRemaining.replace('[amount]',formatted))
        : (remaining === 0 ? this.dataset.success : this.dataset.remaining.replace('[amount]',formatted));
      this.querySelector('[data-message]').textContent = message;
      this.querySelector('[data-fill]').style.width = `${percent}%`;
      const meter = this.querySelector('[role="progressbar"]');
      meter.setAttribute('aria-valuenow',String(Math.round(percent)));
      meter.setAttribute('aria-valuetext',message);
      this.classList.toggle('is-complete',cart.total_price >= target);
    }
  }
  customElements.define('kom-shipping-progress',KomShippingProgress);
})();
